import React from 'react';
import PropTypes from 'prop-types';
import RadioButtonGroup from 'bento-ordering/base/components/RadioButtonGroup';
import CheckBoxGroup from 'bento-ordering/base/components/CheckBoxGroup';
import VariantQuantity from 'catering/components/Forms/MenuItemDetailsForm/VariantQuantity';
import { RADIO_BUTTON, CHECKBOX, QUANTITY } from 'helpers/forms/menuItem';
class VariantInputGroup extends React.Component {
  static propTypes = {
    fieldType: PropTypes.oneOf([RADIO_BUTTON, CHECKBOX, QUANTITY]),
    title: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    checked: PropTypes.bool,
    list: PropTypes.array.isRequired,
    value: PropTypes.any,
    disabled: PropTypes.bool,
    required: PropTypes.bool,
    maxQty: PropTypes.number,
    minQty: PropTypes.number,
    isSizeSection: PropTypes.bool,
    hasInvestorDayFeature: PropTypes.bool
  };

  static defaultProps = {
    value: {},
    isSizeSection: false
  };

  getInputComponent = () => {
    const { fieldType } = this.props;
    const COMPONENT_TYPE = {
      radiobutton: RadioButtonGroup,
      checkbox: CheckBoxGroup,
      quantity: VariantQuantity
    };

    return COMPONENT_TYPE[fieldType];
  };

  render() {
    const {
      title,
      onChange,
      checked,
      list,
      value,
      disabled,
      required,
      maxQty,
      minQty,
      isSizeSection,
      hasInvestorDayFeature
    } = this.props;

    const InputComponent = this.getInputComponent();

    return (
      <InputComponent
        title={title}
        onChange={onChange}
        checked={checked}
        value={value}
        list={list}
        disabled={disabled}
        required={required}
        maxQty={maxQty}
        minQty={minQty}
        isSizeSection={isSizeSection}
        hasInvestorDayFeature={hasInvestorDayFeature}
        {...this.props}
      />
    );
  }
}

export default VariantInputGroup;
